export default "__VITE_ASSET__CaoTwKWX__"